import { Redirect, Switch } from 'react-router';
import {
  PATH_SERVICE,
  PATH_SERVICE_MANAGE_ACCOUNT,
  PATH_SERVICE_MANAGE_API,
  PATH_SERVICE_MANAGE_FORM,
  PATH_SERVICE_USAGE,
} from '@/constants/constant';
import PrivateRoute from '@/routes/PrivateRoute';
import ServiceUsagePage from '@/components/pages/service/ServiceUsagePage';
import ServiceManageAccountPage from '@/components/pages/service/ServiceManageAccountPage';
import ServiceManageApiPage from '@/components/pages/service/ServiceManageApiPage';
import ServiceManageFormPage from '@/components/pages/service/ServiceManageFormPage';

const ServiceRoute = () => {
  return (
    <Switch>
      <PrivateRoute path={PATH_SERVICE_USAGE} component={ServiceUsagePage} />
      <PrivateRoute path={PATH_SERVICE_MANAGE_ACCOUNT} component={ServiceManageAccountPage} />
      <PrivateRoute path={PATH_SERVICE_MANAGE_API} component={ServiceManageApiPage} />
      <PrivateRoute path={PATH_SERVICE_MANAGE_FORM} component={ServiceManageFormPage} />
      <Redirect path={PATH_SERVICE} to={PATH_SERVICE_MANAGE_FORM} />
    </Switch>
  );
};

export default ServiceRoute;
